exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flag-icon{width:30px;height:22px;padding:10px;box-shadow:2.5px 2.5px 3px .05px #333}.flag-icon.disabled{opacity:.5}.lang-selector-container{display:flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/DescrEditor.vue
// module id = 214
// module chunks = 11